// 9fbef606107a605d69c0edbcd8029e5d
export const HEADER_REDUCER_KEY = 'Header';
export const FOOTER_REDUCER_KEY = 'Footer';
export const LABEL_REDUCER_KEY = 'Labels';
export const SEO_DATA_REDUCER_KEY = 'SEOData';
export const LAYOUT_REDUCER_KEY = 'Layouts';
export const PROMO_COMBINATION_REDUCER_KEY = 'PromoCombinations';
export const MODULES_REDUCER_KEY = 'Modules';
export const SUB_NAVIGATION_REDUCER_KEY = 'SubNavigation';
export const NAVIGATION_REDUCER_KEY = 'Navigation';
export const CUSTOM_NAVIGATION_REDUCER_KEY = 'CustomNavigation';
export const PRODUCT_LISTING_REDUCER_KEY = 'ProductListing';
export const PRODUCTLISTING_ACTION_PATTERN = '@@PLP-';
export const FORM_REDUCER_KEY = 'form';
export const LOADER_REDUCER_KEY = 'PageLoader';
export const RECOMMENDATIONS_REDUCER_KEY = 'Recommendations';
export const DY_RECOMMENDATIONS_REDUCER_KEY = 'DyRecommendations';
export const SEARCH_REDUCER_KEY = 'Search';
export const SOCIAL_REDUCER_KEY = 'Social';
export const RECENT_SEARCH_REDUCER_KEY = 'RecentSearches';
export const BUNDLEPRODUCT_REDUCER_KEY = 'BundleProduct';
export const BUNDLEPRODUCT_ACTION_PATTERN = '@@Bundle--';
export const SHOP_BY_PROFILE_ACTION_PATTERN = '@@SBP--';
export const HAPTIC_FEEDBACK_REDUCER_KEY = 'HapticFeedback';

// Don't Add "Reducer" in the Key - it should be LoginPage, not LoginPageReducer

// Login Page Reducer
export const LOGINPAGE_REDUCER_KEY = 'LoginPageReducer';
export const ADDRESSBOOK_REDUCER_KEY = 'AddressBookReducer';
export const ADDRESSBOOK_ACTION_PATTERN = '@@AddressBook-';
export const PAYMENT_REDUCER_KEY = 'PaymentReducer';
export const FORGOTPASSWORD_ACTION_PATTERN = '@@ForgotPassword-';
export const FORGOTPASSWORD_REDUCER_KEY = 'ForgotPasswordReducer';
export const ADDED_TO_BAG_REDUCER_KEY = 'AddedToBagReducer';
export const ADD_GIFT_CARD_REDUCER_KEY = 'AddGiftCardReducer';
export const PAYMENT_ACTION_PATTERN = '@@payment-';
export const ADD_GIFT_CARD_ACTION_PATTERN = '@@AddGiftCard-';
export const LOGINPAGE_ACTION_PATTERN = '@@Login-';
export const ACCOUNTHEADER_ACTION_PATTERN = '@@AccountHeader-';
export const ACCOUNTHEADER_REDUCER_KEY = 'AccountHeader';
export const CARTITEMTILE_REDUCER_KEY = 'CartItemTileReducer';
export const CARTPAGE_REDUCER_KEY = 'CartPageReducer';
export const CARTPAGE_ACTION_PATTERN = '@@CartPage-';
export const NON_CACHED_CART_REDUCER_KEY = 'NonCachedCartReducer';
export const NON_CACHED_CART_ACTION_PATTERN = '@@NonCachedCart-';
export const CHECKOUT_REDUCER_KEY = 'Checkout';
export const OVERLAY_MODAL_REDUCER_KEY = 'OverlayModalReducer';
export const OVERLAY_MODAL_ACTION_PATTERN = '@@Overlay-';
export const BONUS_POINTS_DAYS = '@@Bonus-';
export const BONUS_POINTS_DAYS_REDUCER_KEY = 'BonusPointsDaysReducer';
export const USER_ACTION_PATTERN = '@@User-';
export const USER_REDUCER_KEY = 'User';
export const BIRTHDAY_SAVINGS_ACTION_PATTERN = '@@BirthdaySavings';
export const NAVIGATION_ACTION_PATTERN = '@@Navigation-';
export const RECOMMENDATIONS_ACTION_PATTERN = '@@Recommendations-';
export const DY_RECOMMENDATIONS_ACTION_PATTERN = '@@DyRecommendations-';
export const SOCIAL_ACTION_PATTERN = '@@Social-';
export const CUSTOMER_LOYALTY_REDUCER_KEY = 'CustomerLoyaltyReducer';
export const LOYALTY_PLACE_REWARDS_REDUCER = 'LoyaltyPlaceRewardsReducer';
export const LOYALTY_REWARDS_REDUCER = 'LoyaltyRewardsReducer';

// search listing page reducer
export const SLP_PAGE_REDUCER_KEY = 'SearchListingPage';
export const SEARCH_REDUCER_ACTION_PATTERN = '@@SLP-';

export const MY_FAVORITE_STORE_ACTION_PATTERN = '@@MyFavoriteStore';

// Extra Points promo list reducer
export const EXTRA_POINTS_REDUCER_KEY = 'ExtraPoints';
export const EXTRA_POINTS_ACTION_PATTERN = '@@ExtraPoints';

// acconut page reducer
export const ACCOUNT_REDUCER_KEY = 'AccountReducer';
export const ACCOUNT_ACTION_PATTERN = '@@Account-';

// feature/acconut page reducer
export const CREATE_ACCOUNT_REDUCER_KEY = 'CreateAccountReducer';
export const CREATE_ACCOUNT_ACTION_PATTERN = '@@CreateAccount-';

// Add address page reducer
export const ADDEDITADDRESS_REDUCER_KEY = 'AddEditAddressReducer';
export const ADDEDITADDRESS_ACTION_PATTERN = '@@Address-';

// set api config reducer
export const APICONFIG_REDUCER_KEY = 'APIConfig';
export const APICONFIG_ACTION_PATTERN = '@@APICONFIG-';

// set api config reducer
export const SESSIONCONFIG_REDUCER_KEY = 'session';
export const SESSIONCONFIG_ACTION_PATTERN = '@@SessionConfig-';

// Add/Update Credit Card reducer
export const ADDEDITCREDITCARD_REDUCER_KEY = 'AddEditCreditCardReducer';

// Product Detail Page Reducer
export const PRODUCT_DETAIL_REDUCER_KEY = 'ProductDetail';
export const PRODUCT_DETAIL_ACTION_PATTERN = '@@PDP-';

// Product Pickup Reducer
export const PRODUCT_PICKUP_REDUCER_KEY = 'ProductPickup';
export const PRODUCT_PICKUP_ACTION_PATTERN = '@BOPIS-';

// Quick View Page Reducer
export const QUICK_VIEW_REDUCER_KEY = 'QuickView';
export const QUICK_VIEW_ACTION_PATTERN = '@@QV-';

// Outfit Detail Page Reducer
export const OUTFIT_DETAILS_REDUCER_KEY = 'OutfitDetails';
export const OUTFIT_DETAILS_PATTERN = '@@OutfitDetails-';

// Favorites Reducer
export const FAVORITES_REDUCER_KEY = 'Favorites';
export const FAVORITES_ACTION_PATTERN = '@@Favorites-';

// Email signup reducer
export const EMAIL_SIGNUP_REDUCER_KEY = 'EmailSignUp';
export const SMS_SIGNUP_REDUCER_KEY = 'SmsSignUp';
export const PLCC_OFFER_REDUCER_KEY = 'PlccOffer';

// Country Selector reducer
export const COUNTRY_SELECTOR_REDUCER_KEY = 'CountrySelector';
export const COUNTRY_SELECTOR_ACTION_PATTERN = '@@CountrySelector-';

// Get Candid reducer
export const GET_CANDID_REDUCER_KEY = 'GetCandid';
export const GET_CANDID_ACTION_PATTERN = '@@GetCandid-';

// Coupon reducer
export const COUPON_REDUCER_KEY = 'CouponsAndPromos';
export const COUPON_ACTION_PATTERN = '@@CouponsAndPromos-';

// MergeAccounts reducer
export const MERGE_ACCOUNT_REDUCER_KEY = 'MergeAccount';
export const MERGE_ACCOUNT_REDUCER_PATTERN = '@@MergeAccount-';

// AccountConfirmation reducer
export const MERGE_ACCOUNT_ACCOUNT_CONFIRMATION_REDUCER_KEY = 'AccountConfirmation';
export const MERGE_ACCOUNT_ACCOUNT_CONFIRMATION_REDUCER_PATTERN = '@@AccountConfirmation-';

// MergeAccountOtp reducer
export const MERGE_ACCOUNT_OTP_REDUCER_KEY = 'MergeAccountOtp';
export const MERGE_ACCOUNT_OTP_REDUCER_PATTERN = '@@MergeAccountOtp-';

// Airmiles Banner reducer
export const AIRMILES_BANNER_REDUCER_KEY = 'AirmilesBanner';
export const AIRMILES_BANNER_ACTION_PATTERN = '@@AirmilesBanner-';
// logout reducer
export const LOGOUT_REDUCER_KEY = 'logoutReducer';
export const LOGOUT_ACTION_PATTERN = '@@logout-';

// Ponit History reducer
export const POINTS_HISTORY_REDUCER_KEY = 'pointHistoryReducer';
export const POINTS_HISTORY_ACTION_PATTERN = '@@pointHistory-';

// Earn extra points reducer
export const EARNEXTRAPOINTS_REDUCER_KEY = 'earnExtraPointsReducer';
export const EARNEXTRAPOINTS_ACTION_PATTERN = '@@earnExtraPoints-';

// Earn extra points reducer
export const ORDERDETAILS_REDUCER_KEY = 'OrderDetailsReducer';
export const ORDERDETAILS_ACTION_PATTERN = '@@OrderDetails-';

export const RESET_PASSWORD_REDUCER_KEY = 'ResetPassword';
export const RESET_PASSWORD_ACTION_PATTERN = '@@ResetPassword-';
export const TRACK_ORDER_REDUCER_KEY = 'TrackOrderReducer';
export const TRACK_ORDER_ACTION_PATTERN = '@@TrackOrder-';

// Write Review reducer
export const WRITE_REVIEW_REDUCER_KEY = 'WriteReviewReducer';
export const WRITE_REVIEW_ACTION_PATTERN = '@@WriteReview-';

// change password reducer
export const CHANGE_PASSWORD_REDUCER_KEY = 'ChangePassword';
export const CHANGE_PASSWORD_ACTION_PATTERN = '@@ChangePassword-';

// Update Profile reducer
export const UPDATE_PROFILE_REDUCER_KEY = 'UpdateProfile';
export const UPDATE_PROFILE_ACTION_PATTERN = '@@UpdateProfile-';

// My Profile reducer
export const MY_PROFILE_REDUCER_KEY = 'MyProfile';
export const MY_PROFILE_ACTION_PATTERN = '@@MyProfile-';

// device type detection
export const DEVICE_INFO_REDUCER_KEY = 'DeviceInfo';

// plcc card Page Reducer
export const APPLY_PLCC_REDUCER_KEY = 'ApplyCardPage';
export const APPLY_PLCC_ACTION_PATTERN = '@@ApplyCardPage-';

// ProductTabList reducer
export const PRODUCT_TAB_LIST_REDUCER_KEY = 'ProductTabList';
export const PRODUCT_TAB_LIST_ACTION_PATTERN = '@@ProductTabList-';

export const STYLITICS_PRODUCT_TAB_LIST_REDUCER_KEY = 'StyliticsProductTabList';
export const STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN = '@@StyliticsProductTabList-';

export const MAILING_ADDRESS_REDUCER_KEY = 'AddMailingAddressReducer';
export const BIRTHDAY_SAVING_LIST_REDUCER_KEY = 'BirthdaySavingsList';

// apply now modal for trigger the plcc application flow in modal.
export const APPLY_NOW_MODAL_REDUCER_KEY = 'ApplyNowModal';
export const APPLY_NOW_MODAL_REDUCER_PATTERN = '@@ApplyNowModal-';

// Toggle Pickup modal..
export const PICKUP_MODAL_REDUCER_KEY = 'PickupModal';
export const PICKUP_MODAL_REDUCER_PATTERN = '@@PickupModal-';

export const ADDRESS_VERIFICATION_REDUCER_KEY = 'addressVerification';
// Gift Services Reducer
export const GIFT_SERVICES_REDUCER_KEY = 'GiftServices';
export const GIFT_SERVICES_ACTION_PATTERN = '@@GiftServices-';

// Store Locator Reducer
export const STORE_LOCATOR_REDUCER_KEY = 'StoreLocatorReducer';
export const STORE_LOCATOR_ACTION_PATTERN = '@@StoreLocator-';
export const MY_FAVORITE_STORE_REDUCER_KEY = 'MyFavoriteStore';

// Store Detail Reducer
export const STORE_DETAIL_REDUCER_KEY = 'StoreDetailReducer';
export const STORE_DETAIL_ACTION_PATTERN = '@@StoreDetail-';
export const POINTS_CLAIM_REDUCER_KEY = 'PointsClaim';
export const POINTS_CLAIM_ACTION_PATTERN = '@@PointsClaim-';

// Store International List reducer
export const STORES_INTL_REDUCER_KEY = 'StoresIntl';
export const STORES_INTL_ACTION_PATTERN = '@@StoresIntl-';

export const CONFIRMATION_REDUCER_KEY = 'Confirmation';
export const CONFIRMATION_ACTION_PATTERN = '@@Confirmation-';
export const PRODUCT_ADD_TO_BAG = 'ProductAddToBag';
export const PRODUCT_SKU_SELECTION_FORM = 'PickupSkuSelectionForm';
export const OUTFIT_LISTING_FORM = 'OutfitListingForm';
// User Order History
export const ORDERS_REDUCER_KEY = 'Orders';
export const ORDERS_ACTION_PATTERN = '@@Orders-';
// Store List Reducer
export const STORE_LIST_REDUCER_KEY = 'StoreListReducer';
export const STORE_LIST_ACTION_PATTERN = '@@StoreList-';

// Category List Reducer
export const CATEGORY_LIST_REDUCER_KEY = 'CategoryListReducer';
export const CATEGORY_LIST_ACTION_PATTERN = '@@CategoryList-';

// Site Map Reducer
export const SITEMAP_REDUCER_KEY = 'SiteMapReducer';
export const SITEMAP_ACTION_PATTERN = '@@SiteMap-';

// My Profile reducer
export const MY_PREFERENCE_REDUCER_KEY = 'MyPreference';
export const MY_PREFERENCE_ACTION_PATTERN = '@@MyPreference-';

export const ANALYTICS_DATA_KEY = 'AnalyticsDataKey';

export const AB_TEST_STORE_PATTERN = 'AbTest';

export const APP_VERSION_KEY = 'AppVersion';

export const NAVIGATE_XHR = 'NavigateXHR';

// EDD
export const EDD_REDUCER_KEY = 'Edd';
export const EDD_ACTION_PATTERN = '@@Edd-';

// Redirect
export const REDIRECT_REDUCER_KEY = 'Redirect';
export const REDIRECT_ACTION_PATTERN = '@@Redirect-';

// Customer Help
export const CUSTOMER_HELP_REDUCER_KEY = 'CustomerHelpReducer';
export const CUSTOMER_HELP_ACTION_PATTERN = '@@CustomerHelp-';
// Toggle Pickup modal..
export const QMRECOMMENDATION_MODAL_REDUCER_KEY = 'QMRecommendationModal';
export const QMRECOMMENDATION_MODAL_REDUCER_PATTERN = '@@QMRecommendationModal-';

export const LAST_UPDATED_REDUCER_KEY = 'lastUpdated';

export const SINGLE_PAGE_REDUCER_KEY = 'singlePageCheckout';
export const GIFT_CARD_BALANCE_REDUCER_KEY = 'giftCardBalance';
export const GIFT_CARD_BALANCE_REDUCER_PATTERN = '@@giftCardBalance-';
// AfterPay
export const AFTERPAY_REDUCER_KEY = 'AfterPay';
export const AFTERPAY_ACTION_PATTERN = '@@AfterPay-';

// Adyen
export const ADYEN_REDUCER_KEY = 'AdyenPayment';
export const ADYEN_ACTION_PATTERN = '@@AdyenPayment-';

// merge account email address confirmation
export const MERGE_ACCOUNT_EMAIL_ADDRESS_CONFIRMATION_REDUCER_KEY =
  'MergeAccountEmailAddressConfirmationReducer';
export const MERGE_ACCOUNT_EMAIL_ADDRESS_CONFIRMATION_ACTION_PATTERN =
  '@@MergeAccountEmailAddressConfirmation-';

// Single Signup
export const EMAIL_SMS_SIGNUP_REDUCER_KEY = 'EmailSmsSignUpReducer';
export const EMAIL_SMS_ACTION_PATTERN = '@@EmailSmsSignUp-';

// Accessories Reducer
export const ACCESSORIES_REDUCER_KEY = 'Accessories';
export const ACCESSORIES_REDUCER_PATTERN = '@@Accessories-';
// Bundle Tracker reducer
export const BUNDLE_TRACKER_REDUCER_KEY = 'BundleTracker';
export const BUNDLE_TRACKER_REDUCER_PATTERN = '@@BundleTracker-';
export const PROMOTION_OFFER_DETAIL_REDUCER_KEY = 'PromotionOfferDetailReducer';
export const PROMOTION_OFFER_DETAIL_PATTERN = '@@PromotionOfferDetail-';
// Offer Details Reducer
export const OFFER_DETAILS_REDUCER_KEY = 'OfferDetails';
export const OFFER_DETAILS_ACTION_PATTERN = '@@OD-';
// Promotions Reducer
export const PROMOTIONS_REDUCER_KEY = 'Promotions';
export const PROMOTIONS_REDUCER_KEY_PATTERN = '@@PromotionsReducer-';

// Prouct Rating N Review
export const RATING_REVIEW_REDUCER_KEY = 'RatingReview';
export const RATING_REVIEW_ACTION_PATTERN = '@@RatingReview-';
// birthday module home page
export const BIRTHDAY_MODULE_REDUCER_KEY = 'BirthdayModule';
export const BIRTHDAY_HP_MODULE_ACTION_PATTERN = '@@BirthdayHP-';

export const BIRTHDAY_PRODUCT_LISTING__REDUCER_KEY = 'BirthdayProductListing';
export const BIRTHDAY_PRODUCT_LISTING___ACTION_PATTERN = '@@BirthdayProductListing_';

// Size Chart
export const SIZE_CHART_REDUCER_KEY = 'SizeChart';
export const SIZE_CHART_PATTERN = '@@SizeChart-';
// Dashboard Overview Order by Shipment
export const DASHBOARD_ORDERS_REDUCER_KEY = 'DashboardOrders';
export const DASHBOARD_ORDERS_ACTION_PATTERN = '@@DashboardOrders-';
// Place Perks Dashboard Redeemed And Earned Perks
export const REDEEMED_AND_EARNED_PERKS_REDUCER_KEY = 'RedeemedAndEarnedPerks';
export const REDEEMED_AND_EARNED_PERKS_ACTION_PATTERN = '@@RedeemedAndEarnedPerks-';

// CarouselTab reducer
export const CAROUSEL_TAB_REDUCER_KEY = 'CarouselTab';
export const CAROUSEL_TAB_ACTION_PATTERN = '@@CarouselTab-';

export const STYLITICS_CAROUSEL_REDUCER_KEY = 'StyliticsCarousel';
export const STYLITICS_CAROUSEL_ACTION_PATTERN = '@@StyliticsCarousel-';

export const HORIZONTAL_CATEGORY_REDUCER_KEY = 'HorizontalCategory';

// Dynamic Size Chart
export const DYNAMIC_SIZE_CHART_REDUCER_KEY = 'DynamicSizeChart';
export const DYNAMIC_SIZE_CHART_PATTERN = '@@DynamicSizeChart-';

// Shop by Look Stylitics reducer.
export const SHOP_BY_LOOK_STYLITICS_REDUCER_KEY = 'shopByLookStylitics';
export const SHOP_BY_LOOK_STYLITICS_ACTION_PATTERN = '@@ShopByLookStylitics-';

export const REDUCER_ACTION_MAPPING = {
  [APPLY_PLCC_REDUCER_KEY]: APPLY_PLCC_ACTION_PATTERN,
  [APICONFIG_REDUCER_KEY]: APICONFIG_ACTION_PATTERN,
  [SESSIONCONFIG_REDUCER_KEY]: SESSIONCONFIG_ACTION_PATTERN,
  [NAVIGATE_XHR]: NAVIGATE_XHR,
  [LOGINPAGE_REDUCER_KEY]: LOGINPAGE_ACTION_PATTERN,
  [FORGOTPASSWORD_REDUCER_KEY]: FORGOTPASSWORD_ACTION_PATTERN,
  [PRODUCT_LISTING_REDUCER_KEY]: PRODUCTLISTING_ACTION_PATTERN,
  [ADDRESSBOOK_REDUCER_KEY]: ADDRESSBOOK_ACTION_PATTERN,
  [PAYMENT_REDUCER_KEY]: PAYMENT_ACTION_PATTERN,
  [ADD_GIFT_CARD_REDUCER_KEY]: ADD_GIFT_CARD_ACTION_PATTERN,
  [CREATE_ACCOUNT_REDUCER_KEY]: CREATE_ACCOUNT_ACTION_PATTERN,
  [LOGOUT_REDUCER_KEY]: LOGOUT_ACTION_PATTERN,
  [POINTS_HISTORY_REDUCER_KEY]: POINTS_HISTORY_ACTION_PATTERN,
  [EARNEXTRAPOINTS_REDUCER_KEY]: EARNEXTRAPOINTS_ACTION_PATTERN,
  [ORDERDETAILS_REDUCER_KEY]: ORDERDETAILS_ACTION_PATTERN,
  [RESET_PASSWORD_REDUCER_KEY]: RESET_PASSWORD_ACTION_PATTERN,
  [COUNTRY_SELECTOR_REDUCER_KEY]: COUNTRY_SELECTOR_ACTION_PATTERN,
  [TRACK_ORDER_REDUCER_KEY]: TRACK_ORDER_ACTION_PATTERN,
  [CHANGE_PASSWORD_REDUCER_KEY]: CHANGE_PASSWORD_ACTION_PATTERN,
  [UPDATE_PROFILE_REDUCER_KEY]: UPDATE_PROFILE_ACTION_PATTERN,
  [PRODUCT_DETAIL_REDUCER_KEY]: PRODUCT_DETAIL_ACTION_PATTERN,
  [PRODUCT_PICKUP_REDUCER_KEY]: PRODUCT_PICKUP_ACTION_PATTERN,
  [AFTERPAY_REDUCER_KEY]: AFTERPAY_ACTION_PATTERN,
  [ADYEN_REDUCER_KEY]: ADYEN_ACTION_PATTERN,
  [GET_CANDID_REDUCER_KEY]: GET_CANDID_ACTION_PATTERN,
  [MY_PROFILE_REDUCER_KEY]: MY_PROFILE_ACTION_PATTERN,
  [PRODUCT_TAB_LIST_REDUCER_KEY]: PRODUCT_TAB_LIST_ACTION_PATTERN,
  [STYLITICS_PRODUCT_TAB_LIST_REDUCER_KEY]: STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN,
  [NAVIGATION_REDUCER_KEY]: NAVIGATION_ACTION_PATTERN,
  [APPLY_NOW_MODAL_REDUCER_KEY]: APPLY_NOW_MODAL_REDUCER_PATTERN,
  [PICKUP_MODAL_REDUCER_KEY]: PICKUP_MODAL_REDUCER_PATTERN,
  [RECOMMENDATIONS_REDUCER_KEY]: RECOMMENDATIONS_ACTION_PATTERN,
  [DY_RECOMMENDATIONS_REDUCER_KEY]: DY_RECOMMENDATIONS_ACTION_PATTERN,
  [STORE_LOCATOR_REDUCER_KEY]: STORE_LOCATOR_ACTION_PATTERN,
  [SEARCH_REDUCER_KEY]: SEARCH_REDUCER_ACTION_PATTERN,
  [SLP_PAGE_REDUCER_KEY]: SEARCH_REDUCER_ACTION_PATTERN,
  [STORE_DETAIL_REDUCER_KEY]: STORE_DETAIL_ACTION_PATTERN,
  [CONFIRMATION_REDUCER_KEY]: CONFIRMATION_ACTION_PATTERN,
  [STORES_INTL_REDUCER_KEY]: STORES_INTL_ACTION_PATTERN,
  [OUTFIT_DETAILS_REDUCER_KEY]: OUTFIT_DETAILS_PATTERN,
  [STORE_LIST_REDUCER_KEY]: STORE_LIST_ACTION_PATTERN,
  [MY_PREFERENCE_REDUCER_KEY]: MY_PREFERENCE_ACTION_PATTERN,
  [BUNDLEPRODUCT_REDUCER_KEY]: BUNDLEPRODUCT_ACTION_PATTERN,
  [COUPON_REDUCER_KEY]: COUPON_ACTION_PATTERN,
  [SOCIAL_REDUCER_KEY]: SOCIAL_ACTION_PATTERN,
  [SITEMAP_REDUCER_KEY]: SITEMAP_ACTION_PATTERN,
  [USER_REDUCER_KEY]: USER_ACTION_PATTERN,
  [CUSTOM_NAVIGATION_REDUCER_KEY]: CUSTOM_NAVIGATION_REDUCER_KEY,
  [EDD_REDUCER_KEY]: EDD_ACTION_PATTERN,
  [REDIRECT_REDUCER_KEY]: REDIRECT_ACTION_PATTERN,
  [CUSTOMER_HELP_REDUCER_KEY]: CUSTOMER_HELP_ACTION_PATTERN,
  [QMRECOMMENDATION_MODAL_REDUCER_KEY]: QMRECOMMENDATION_MODAL_REDUCER_PATTERN,
  [SINGLE_PAGE_REDUCER_KEY]: SINGLE_PAGE_REDUCER_KEY,
  [CARTPAGE_REDUCER_KEY]: CARTPAGE_ACTION_PATTERN,
  [NON_CACHED_CART_REDUCER_KEY]: NON_CACHED_CART_ACTION_PATTERN,
  [GIFT_CARD_BALANCE_REDUCER_KEY]: GIFT_CARD_BALANCE_REDUCER_PATTERN,
  [MERGE_ACCOUNT_EMAIL_ADDRESS_CONFIRMATION_REDUCER_KEY]:
    MERGE_ACCOUNT_EMAIL_ADDRESS_CONFIRMATION_ACTION_PATTERN,
  [EMAIL_SMS_SIGNUP_REDUCER_KEY]: EMAIL_SMS_ACTION_PATTERN,
  [MERGE_ACCOUNT_OTP_REDUCER_KEY]: MERGE_ACCOUNT_OTP_REDUCER_PATTERN,
  [ACCESSORIES_REDUCER_KEY]: ACCESSORIES_REDUCER_PATTERN,
  [PROMOTION_OFFER_DETAIL_REDUCER_KEY]: PROMOTION_OFFER_DETAIL_PATTERN,
  [OFFER_DETAILS_REDUCER_KEY]: OFFER_DETAILS_ACTION_PATTERN,
  [WRITE_REVIEW_REDUCER_KEY]: WRITE_REVIEW_ACTION_PATTERN,
  [ORDERS_REDUCER_KEY]: ORDERS_ACTION_PATTERN,
  [DASHBOARD_ORDERS_REDUCER_KEY]: DASHBOARD_ORDERS_ACTION_PATTERN,
  [REDEEMED_AND_EARNED_PERKS_REDUCER_KEY]: REDEEMED_AND_EARNED_PERKS_ACTION_PATTERN,
  [CAROUSEL_TAB_REDUCER_KEY]: CAROUSEL_TAB_ACTION_PATTERN,
  [STYLITICS_CAROUSEL_REDUCER_KEY]: STYLITICS_CAROUSEL_ACTION_PATTERN,
  [SHOP_BY_LOOK_STYLITICS_REDUCER_KEY]: [SHOP_BY_LOOK_STYLITICS_ACTION_PATTERN],
};
